import React, { Component } from "react";
import BaseModal from "../base_modal";
import { Button, Row, Col, Grid } from "react-bootstrap";
import ExternalLink from "../../lib/external_link";
import { Link } from "react-router-dom";
import "./welcome_modal.scss";

const defaultModal = "default";
const sponsoredUserModal = "sponsoredUserModal";
const invitedUserModal = "invitedUserModal";

class WelcomeModal extends Component {
  getDynamicIntro = key => {
    switch (key) {
      case sponsoredUserModal:
        return <>We want to thank you for supporting creators.</>;
      default:
        return (
          <>
            <p>
              We{"'"}re excited to have you join us! At RedCircle, we’re focused on supporting you
              as a creator and amplifying your voice.{" "}
            </p>

            <p>
              Our platform provides all the services you need to share your podcast with the world.
              We host your podcast and distribute it to all the major players including Apple,
              Spotify, Google, and Stitcher. Once your show is up and running, you can dive into our
              analytics, which will tell you all about your listeners.
            </p>
          </>
        );
    }
  };

  getDynamicBody = key => {
    switch (key) {
      case invitedUserModal:
        return (
          <>
            <h3>
              <span className="italic">{this.props.show.title}</span> is almost set up!
            </h3>
            The only step is to{" "}
            <Link
              onClick={this.props.closeModal}
              to={`/shows/${this.props.show.uuid}/redirect-help`}>
              redirect your show{" "}
            </Link>
            to RedCircle.
          </>
        );
      case sponsoredUserModal:
        return (
          <p>
            You can view the shows you're sponsoring{" "}
            <Link onClick={this.props.closeModal} to={`/sponsor-show-list`}>
              here.
            </Link>
          </p>
        );
      default:
        return (
          <>
            <h3>Starting a new podcast?</h3>
            <p>
              {" "}
              <ExternalLink href="https://support.redcircle.com/redcircle-basics/getting-started">
                Read our guide
              </ExternalLink>{" "}
              to getting started or{" "}
              <Link onClick={this.props.closeModal} to="/shows/create">
                create your first show
              </Link>
              .
            </p>
            <h3>Importing your existing podcast?</h3>
            <p>
              You can{" "}
              <Link onClick={this.props.closeModal} to="/shows/import">
                import your show here
              </Link>
              . Switching to RedCircle only takes a few minutes!
            </p>
          </>
        );
    }
  };

  render() {
    let modalToShow = defaultModal;
    if (this.props.isInvitedUser && this.props.show) {
      modalToShow = invitedUserModal;
    } else if (this.props.isSponsoredUser) {
      modalToShow = sponsoredUserModal;
    }
    const dynamicBody = this.getDynamicBody(modalToShow);
    const dynamicIntro = this.getDynamicIntro(modalToShow);

    return (
      <BaseModal
        isLoading={false}
        isMini={true}
        columns={12}
        offset={0}
        title={"Welcome to RedCircle!"}
        close={this.props.closeModal}
        hideCloseButton={true}
        showContent={true}
        Content={() => (
          <Grid fluid>
            <Row>
              <Col xs={12}>
                {dynamicIntro}
                {dynamicBody}
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <div className="welcome-modal-footer">
                  <Button className="btn btn-primary" onClick={this.props.closeModal}>
                    Close
                  </Button>
                </div>
              </Col>
            </Row>
          </Grid>
        )}
      />
    );
  }
}

export default WelcomeModal;
